import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ContentLoader from 'controls/content-loader/ContentLoader';

import request from 'actions/request';

class AvaliableRecordersSelector extends Component {
  componentWillMount() {
    if (this.props.fdrsPending !== false) {
      this.props.request(
        ['recorders', 'getAll'],
        'get',
        'RECORDERS'
      );
    }
  }

  buildList() {
    let recorders = this.props.recorders.items;

    if (!recorders || recorders.length === 0) {
      return [];
    }

    return recorders.map((item) => {
      return <option key={ item.id } value={ item.id }>{ item.name }</option>
    });
  }

  render() {
    if (this.props.fdrsPending !== false) {
      return <ContentLoader margin={ 5 } size={ 75 } />
    }

    return (
      <select className="form-control" name="avaliableRecorders[]" multiple="multiple">
        { this.buildList() }
      </select>
    );
  }
}

function mapStateToProps(state) {
  return {
    fdrsPending: state.recorders.pending,
    recorders: state.recorders,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AvaliableRecordersSelector);
